<template>
    <b-container>
        <b-card>
        <h1 class="mb-3">Mobile Carriers</h1>
        <b-row>
            <b-col>
                <b-button class="mb-2" variant="primary" :to="{name: 'carrier-detail', params: { 'carrierId': null}}" >Create Carrier <font-awesome-icon icon="plus" /></b-button>
            </b-col>
        </b-row>
        <b-row class="mb-3 mt-3">
            <b-col cols="9">
                <b-form-input v-model="searchTerm" placeholder="Search for Carriers"></b-form-input>
            </b-col>
            <b-col>
                <b-button variant="secondary" v-on:click="filterCarriers"><font-awesome-icon icon="search" /> Search</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    class="mb-3 mt-3"
                    striped
                    show-empty
                    responsive
                    empty-text="No Carriers to show"
                    outlined>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                    <template #cell(fee)="row">
                        ${{ row.item.fee }}
                    </template>
                    <template v-slot:cell(action)="row">
                        <span :id="'tooltip-updated-' + row.index">
                            <b-button
                            :key="row.item.carrier_id"
                            :to="{name: 'carrier-detail', params: { 'carrierId': row.item.carrier_id}}"
                            :variant="!row.item.needs_review ? 'outline-secondary': 'danger'">
                            <font-awesome-icon icon="edit" />
                        </b-button>
                            </span>
                            <b-tooltip :target="'tooltip-updated-' + row.index" triggers="hover" v-if="row.item.needs_review">
                                You need to review the rate for this carrier!
                            </b-tooltip>

            </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
                <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchCarriers(currentPage-1)">Prev</b-button>
                    <b-button @click="searchCarriers(currentPage+1)">Next</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        </b-col>
        </b-row>
    </b-card>
    </b-container>
</template>
<script>
import { CarrierApi } from "@/app/carriers/carrierApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";

export default {
    name: "CarrierList",
    data () {
        return {
            searchTerm: null,
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null,
                page_size: 10,
                search_term: null
            },
            prevPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null,
                page_size: 10,
                search_term: null
            },
            pages: [],
            currentPage: 0,
            lastPage: 0,
            table: {
                id: "carrier-list",
                fields: [
                    {
                        key: "carrier_name",
                        label: "Carrier Name"
                    },
                    {
                        key: "fee",
                        label: "Segment Fee"
                    },
                    {
                        key: "action",
                        label: "Action"
                    }
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 10
                }
            }
        }
    },
    async mounted() {
        this.pages.push(this.nextPage);
        await this.searchCarriers(0);
    },
    methods: {
        async searchCarriers(page) {
            if (page < 0) {
                return;
            }
            if (page > this.pages.length -1) {
                return;
            }
            let payload = this.pages[page];
            this.table.isBusy = true;
            payload.search_term = this.searchTerm;
            try {
                const { data } = await CarrierApi.getCarrierList(payload);
                if (data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.result;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch carriers");
            }
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async filterCarriers() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchCarriers(0);

        }
    }

}
</script>
